/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
import {useUserContext} from "../../../contexts/userContext";
/* Components */
/* Styles */
import styles from "./styles.js"



const BookingsTab = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  const userDetails = useUserContext();
  // const location = useLocation();

  // const [gridOptions, setGridOptions] = useState(() => {
  //   const initialPage = location.pathname.includes('/bookings')
  //     ? new URLSearchParams(location.search).get('page') || 1
  //     : 1;
  //   return {
  //     page: +initialPage,
  //   };
  // });
  
  // const { membersList, getMembersList, deleteMember } = useTeamService();

  // useEffect(() => {
  //   getMembersList(gridOptions, teamId);
  // }, [gridOptions])

  // useEffect(() => {
  //   const pageFromURL = location.pathname.includes('/bookings')
  //     ? new URLSearchParams(location.search).get('page') || 1
  //     : 1;
  //   if (+pageFromURL !== gridOptions.page) {
  //     setGridOptions({ ...gridOptions, page: pageFromURL });
  //   }
  // }, [location.search]);


  return (
    <div className={classes.bookingsTab}>
      Bookings tab
    </div>
  )
}

export default BookingsTab;
